import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';
// import { playerGamelogPitcher, playerGamelogBatter } from './data';
import { detectIconById } from '../common/enum';
import { numeralFormat } from '../common/numeralFormat';

const ACTIONS_PLAYER = {
    GET_PLAYER_GAMELOG_SUCCESS: 'GET_PLAYER_GAMELOG_SUCCESS',
    GET_PLAYER_GAMELOG_ERROR: 'GET_PLAYER_GAMELOG_ERROR',
    GET_PLAYER_GAMELOG_PITCHER_SUCCESS: 'GET_PLAYER_GAMELOG_PITCHER_SUCCESS',
    GET_PLAYER_GAMELOG_PITCHER_ERROR: 'GET_PLAYER_GAMELOG_PITCHER_ERROR',
    GET_PLAYER_GAMELOG_BATTER_SUCCESS: 'GET_PLAYER_GAMELOG_BATTER_SUCCESS',
    GET_PLAYER_GAMELOG_BATTER_ERROR: 'GET_PLAYER_GAMELOG_BATTER_ERROR'
};

const updateStatus = (type, data) => ({
    type,
    data,
});

const getPlayerGamelog = (player_id, year_id) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    // player_id
    // year_id
    let url = `${host.serverTest}api/players/${player_id}/years/${year_id}/results/gamelogs`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                if (data.error) {
                    dispatch(updateStatus(ACTIONS_PLAYER.GET_PLAYER_GAMELOG_ERROR, data.error));
                } else {
                    dispatch(updateStatus(ACTIONS_PLAYER.GET_PLAYER_GAMELOG_SUCCESS, data));
                }
            },
            (err) => {

                dispatch(updateStatus(ACTIONS_PLAYER.GET_PLAYER_GAMELOG_ERROR, err));
            });
    };
};


const getPlayerGamelogPitcher = (data) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    // player_id 1200041
    // year_id 30015
    // month_id
    let url = `${host.serverTest}api/players/${data.player_id}/years/${data.year_id}/month/${data.month_id}/results/gamelogs/types/pitcher`;
    return (dispatch) => {
        callApi(url, config,
            (res) => {
                if (res.error) {
                    dispatch(updateStatus(ACTIONS_PLAYER.GET_PLAYER_GAMELOG_PITCHER_ERROR, res.error));
                } else {
                    dispatch(updateStatus(ACTIONS_PLAYER.GET_PLAYER_GAMELOG_PITCHER_SUCCESS, res));
                }

            },
            (err) => {
                dispatch(updateStatus(ACTIONS_PLAYER.GET_PLAYER_GAMELOG_PITCHER_ERROR, err));
            });
    };
};


const getPlayerGamelogBatter = (data) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    // player_id 1200041
    // year_id 30015
    // month_id
    let url = `${host.serverTest}api/players/${data.player_id}/years/${data.year_id}/month/${data.month_id}/results/gamelogs/types/batter`;
    return (dispatch) => {
        callApi(url, config,
            (res) => {
                if (res.error) {
                    dispatch(updateStatus(ACTIONS_PLAYER.GET_PLAYER_GAMELOG_BATTER_ERROR, res.error));
                } else {
                    dispatch(updateStatus(ACTIONS_PLAYER.GET_PLAYER_GAMELOG_BATTER_SUCCESS, res));
                }

            },
            (err) => {
                dispatch(updateStatus(ACTIONS_PLAYER.GET_PLAYER_GAMELOG_BATTER_ERROR, err));
            });
    };
};

const converPlayerGamelogPitcher = (data) => {

    const arr = data.pitcher.map((value, index) => {
        return {
            key: index,
            table: 1,
            item: [
                {
                    img: true,
                    toggle: true,
                    src: '/img/content/add_24px.svg',
                    time: Math.random(),
                    teamName: value.opponent_team_name,
                },
                { text: value.month + '月', month_id: value.id < 10 ? `0${value.id}` : `${value.id}` },
                { text: '' },
                { text: `${value.w}勝${value.l}敗${value.sv}S${value.hld}H` },
                { text: value.cg },
                { text: value.tosho },
                { text: (value.ip_frac && value.ip_frac !== 0) ? value.ip + value.ip_frac / 10 : value.ip },
                { text: value.np },
                { text: value.bf },
                { text: value.h },
                { text: value.hr },
                { text: value.bb },
                { text: value.hbp },
                { text: value.so },
                { text: value.wp },
                { text: value.bk },
                { text: value.r },
                { text: value.er },
                { text: value.era },
                { text: value.bb_9 },
                { text: value.k9 },
                { text: value.k_bb },
                { text: value.whip },
            ]
        }
    });
    return arr;
}


const converPlayerGamelogBatter = (data) => {
    const arr = data.batter.map((value, index) => {
        return {
            key: index,
            table: 2,
            item: [
                {
                    img: true,
                    toggle: true,
                    src: '/img/content/add_24px.svg',
                    time: Math.random(),
                    teamName: value.opponent_team_name,
                },
                { text: value.month + '月', month_id: value.id < 10 ? `0${value.id}` : `${value.id}` },
                { text: '' },
                { text: value.pa },
                { text: value.ab },
                { text: value.r },
                { text: value.h },
                { text: value.h2b },
                { text: value.h3b },
                { text: value.hr },
                { text: value.tb },
                { text: value.rbi },
                { text: value.so },
                { text: value.bb },
                { text: value.ibb },
                { text: value.hbp },
                { text: value.sh },
                { text: value.sf },
                { text: value.sb },
                { text: value.cs },
                { text: value.gidp },
                { text: value.e },
                { text: numeralFormat(value.avg, 3) },
                { text: numeralFormat(value.slg, 3) },
                { text: numeralFormat(value.obp, 3) },
                { text: numeralFormat(value.ops, 3) },
            ]
        }
    });
    return arr;
}

const converPlayerGamelogItem1 = (data, position, time) => {
    if (data) {
        const arr = data.map((value, index) => {
            return {
                item: [
                    { text: '', pos: position, time_child: time },
                    { text: value.game_display_date },
                    {
                        text: "",
                        img: value ? detectIconById(value.opponent_team_id) : null,
                        url: '/team-report/' + value.opponent_team_id,
                        link: true,
                        teamName: value.opponent_team_name,
                    },
                    { text: (value.w === 1) ? '○' : (value.l === 1) ? '●' : (value.sv === 1) ? 'S' : (value.hld === 1) ? 'H' : "-" },
                    { text: value.cg },
                    { text: value.tosho },
                    { text: value.ip },
                    { text: value.np },
                    { text: value.bf },
                    { text: value.h },
                    { text: value.hr },
                    { text: value.bb },
                    { text: value.hbp },
                    { text: value.so },
                    { text: value.wp },
                    { text: value.bk },
                    { text: value.r },
                    { text: value.er },
                    { text: value.era },
                    { text: value.bb_9 },
                    { text: value.k9 },
                    { text: value.k_bb },
                    { text: value.whip }
                ]
            }
        });
        return arr;
    }
}

const converPlayerGamelogItem2 = (data, position, time) => {
    if (data.length) {
        const arr = data.map((value, index) => {
            return {
                item: [
                    { text: '', pos: position, time_child: time },
                    { text: value.game_display_date },
                    {
                        text: '',
                        img: detectIconById(value.opponent_team_id),
                        url: '/team-report/' + value.opponent_team_id,
                        link: true,
                        teamName: value.opponent_team_name,
                    },
                    { text: value.pa },
                    { text: value.ab },
                    { text: value.r },
                    { text: value.h },
                    { text: value.h2b },
                    { text: value.h3b },
                    { text: value.hr },
                    { text: value.tb },
                    { text: value.rbi },
                    { text: value.so },
                    { text: value.bb },
                    { text: value.ibb },
                    { text: value.hbp },
                    { text: value.sh },
                    { text: value.sf },
                    { text: value.sb },
                    { text: value.cs },
                    { text: value.gidp },
                    { text: value.e },
                    { text: numeralFormat(value.avg, 3) },
                    { text: numeralFormat(value.slg, 3) },
                    { text: numeralFormat(value.obp, 3) },
                    { text: numeralFormat(value.ops, 3) },
                ]
            }
        });
        return arr;
    }
}



export {
    ACTIONS_PLAYER, getPlayerGamelog, converPlayerGamelogPitcher, converPlayerGamelogBatter,
    getPlayerGamelogPitcher, converPlayerGamelogItem1,
    getPlayerGamelogBatter, converPlayerGamelogItem2
};
